import { useQuery } from '@tanstack/react-query';

import { getProductPrices } from '../apis/product';
import type { GetProductPriceType } from '../types/product/shared';

export const useProductPriceQuery = ({
  productsIds,
  enabled,
}: {
  productsIds: string[];
  enabled?: boolean;
}) => {
  const productQuery = useQuery(
    ['related-product', ...productsIds],
    async () => {
      const { data } = await getProductPrices(productsIds);

      return data;
    },
    { enabled, keepPreviousData: true },
  );

  // price response doesn't have any order ,so we need 'findPrice' to select prive
  const findPrice = (id: string, prices?: GetProductPriceType[]) =>
    (prices && prices.find((e) => e.id === id)?.minPrice) || '';

  return {
    productQuery,
    findPrice,
  };
};
